/* ------------------------------------------------------------------ */
/*  Chillkar theme — vanilla JS replacing the old React contexts.      */
/*  Handles: theme toggle, mobile menu, header scroll, cart + search   */
/*  drawers (Shopify AJAX Cart + Section Rendering API), hero video,   */
/*  and the announcement marquee.                                      */
/* ------------------------------------------------------------------ */
(function () {
  "use strict";

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* -------------------- Theme (light / dark) -------------------- */
  function applyTheme(t) {
    document.documentElement.classList.toggle("dark", t === "dark");
    try { localStorage.setItem("chillkar-theme", t); } catch (e) {}
  }
  function currentTheme() {
    try { return localStorage.getItem("chillkar-theme") || "dark"; } catch (e) { return "dark"; }
  }
  document.addEventListener("click", (e) => {
    const set = e.target.closest("[data-set-theme]");
    if (set) { applyTheme(set.getAttribute("data-set-theme")); return; }
    const toggle = e.target.closest("[data-theme-toggle]");
    if (toggle) { applyTheme(currentTheme() === "dark" ? "light" : "dark"); }
  });

  /* -------------------- Header scroll behaviour ----------------- */
  const header = $("[data-site-header]");
  const pill = $("[data-nav-pill]");
  function onScroll() {
    if (!header) return;
    const scrolled = window.scrollY > 24;
    // Swap between the two translate classes so only one is ever applied
    // (both set the same Tailwind translate var) — this hides the marquee on scroll.
    header.classList.toggle("-translate-y-10", scrolled);
    header.classList.toggle("translate-y-0", !scrolled);
    if (pill) {
      pill.classList.toggle("border-[var(--color-border-soft)]", scrolled);
      pill.classList.toggle("bg-[var(--color-surface-soft)]", scrolled);
      pill.classList.toggle("shadow-[0_12px_42px_var(--color-card-shadow)]", scrolled);
      pill.classList.toggle("backdrop-blur-2xl", scrolled);
      pill.classList.toggle("border-transparent", !scrolled);
      pill.classList.toggle("bg-transparent", !scrolled);
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* -------------------- Mobile menu ----------------------------- */
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-mobile-toggle]")) {
      const menu = $("[data-mobile-menu]");
      if (menu) menu.classList.toggle("hidden");
    }
  });

  /* -------------------- Generic drawer open/close --------------- */
  function openDrawer(root, panel, scrim) {
    if (!root) return;
    root.classList.remove("pointer-events-none");
    root.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      if (scrim) scrim.classList.replace("opacity-0", "opacity-100");
      if (panel) {
        panel.classList.remove("translate-x-full", "-translate-y-full");
      }
    });
    document.body.style.overflow = "hidden";
  }
  function closeDrawer(root, panel, scrim, hiddenClass) {
    if (!root) return;
    if (scrim) scrim.classList.replace("opacity-100", "opacity-0");
    if (panel) panel.classList.add(hiddenClass);
    root.setAttribute("aria-hidden", "true");
    setTimeout(() => root.classList.add("pointer-events-none"), 300);
    document.body.style.overflow = "";
  }

  /* -------------------- Cart drawer ----------------------------- */
  const cartRoot = $("[data-cart-root]");
  const cartPanel = $("[data-cart-panel]");
  const cartScrim = $("[data-cart-scrim]");

  function openCart() { openDrawer(cartRoot, cartPanel, cartScrim); }
  function closeCart() { closeDrawer(cartRoot, cartPanel, cartScrim, "translate-x-full"); }

  async function refreshCart() {
    try {
      const res = await fetch(`${window.location.pathname}?sections=cart-drawer`, { headers: { "X-Requested-With": "XMLHttpRequest" } });
      const data = await res.json();
      const html = data["cart-drawer"];
      if (!html) return;
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const newBody = $("[data-cart-body]", tmp);
      const newFooter = $("[data-cart-footer]", tmp);
      if (newBody) $("[data-cart-body]").innerHTML = newBody.innerHTML;
      if (newFooter) {
        const footer = $("[data-cart-footer]");
        footer.innerHTML = newFooter.innerHTML;
        footer.className = newFooter.className;
      }
    } catch (e) { /* fall back to a hard navigation if needed */ }

    // Update the header bag counter from the cart JSON.
    try {
      const cart = await (await fetch("/cart.js")).json();
      const badge = $("[data-cart-count]");
      if (badge) {
        badge.textContent = cart.item_count;
        badge.classList.toggle("hidden", cart.item_count === 0);
      }
    } catch (e) {}
  }

  function showCartError(form, msg) {
    if (!form) { return; }
    let el = form.querySelector("[data-cart-error]");
    if (!el) {
      el = document.createElement("p");
      el.setAttribute("data-cart-error", "");
      el.className = "mt-3 text-sm text-[var(--color-brand-danger)]";
      form.appendChild(el);
    }
    el.textContent = msg;
  }

  async function cartAdd(id, quantity, form, opts) {
    if (!id) { showCartError(form, "Please choose an option first."); return; }
    if (form) showCartError(form, "");
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: id, quantity: quantity || 1 }),
      });
      if (!res.ok) {
        let msg = "Sorry, this item can't be added right now.";
        try { const data = await res.json(); if (data && data.description) msg = data.description; } catch (e) {}
        showCartError(form, msg);
        return;
      }
      // Buy it now goes straight to checkout: no point refreshing the drawer
      // the shopper is about to navigate away from.
      if (opts && opts.redirectTo) { window.location.assign(opts.redirectTo); return; }
      await refreshCart();
      openCart();
    } catch (err) {
      showCartError(form, "Network error — please try again.");
    }
  }

  async function cartChange(line, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    await refreshCart();
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); openCart(); return; }
    if (e.target.closest("[data-close-cart]") || e.target.closest("[data-cart-scrim]")) { closeCart(); return; }

    const plus = e.target.closest("[data-cart-plus]");
    const minus = e.target.closest("[data-cart-minus]");
    const remove = e.target.closest("[data-cart-remove]");
    if (plus || minus || remove) {
      const el = plus || minus || remove;
      const line = parseInt(el.getAttribute("data-line"), 10);
      const li = el.closest("[data-line-item]");
      const qtyEl = li ? $("span.min-w-4", li) : null;
      const current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      let next = current;
      if (plus) next = current + 1;
      if (minus) next = current - 1;
      if (remove) next = 0;
      cartChange(line, next);
    }
  });

  // Which submit button was pressed. e.submitter covers modern browsers; this
  // capture-phase click is the fallback for Safari below 15.4.
  let lastSubmitter = null;
  document.addEventListener("click", (e) => {
    const b = e.target.closest("button[type='submit'], input[type='submit']");
    if (b) lastSubmitter = b;
  }, true);

  // Intercept any product add-to-cart form so it uses the drawer instead of reloading.
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("form[action*='/cart/add']");
    if (!form) return;
    e.preventDefault();
    const idField = form.querySelector("[name='id']");
    const qtyField = form.querySelector("[name='quantity']");
    if (!idField) return;

    // Feedback goes on the button actually pressed, not just the first submit
    // in the form, now that there can be two.
    const submitter = e.submitter || lastSubmitter;
    const btn = (submitter && form.contains(submitter)) ? submitter : form.querySelector("[type='submit']");
    const buyNow = !!(btn && btn.hasAttribute("data-buy-now"));

    let original;
    if (btn) { original = btn.textContent; btn.textContent = buyNow ? "Redirecting…" : "Adding…"; btn.disabled = true; }

    // Honour a subfolder locale root (/en-gb/checkout) rather than assuming /checkout.
    let opts = null;
    if (buyNow) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const base = root.charAt(root.length - 1) === "/" ? root.slice(0, -1) : root;
      opts = { redirectTo: base + "/checkout" };
    }

    // Quantity comes from the stepper for BOTH buttons. Guarded because the
    // field can be momentarily empty if cleared and clicked before blur clamps it.
    const qty = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);
    Promise.resolve(cartAdd(idField.value, qty, form, opts))
      .finally(() => { if (btn) { btn.textContent = original; btn.disabled = false; } });
  });

  /* -------------------- Search drawer --------------------------- */
  const searchRoot = $("[data-search-root]");
  const searchPanel = $("[data-search-panel]");
  const searchScrim = $("[data-search-scrim]");
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-search]")) {
      e.preventDefault();
      openDrawer(searchRoot, searchPanel, searchScrim);
      setTimeout(() => { const i = $("[data-search-input]"); if (i) i.focus(); }, 320);
      return;
    }
    if (e.target.closest("[data-close-search]") || e.target.closest("[data-search-scrim]")) {
      closeDrawer(searchRoot, searchPanel, searchScrim, "-translate-y-full");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
      closeDrawer(searchRoot, searchPanel, searchScrim, "-translate-y-full");
    }
  });

  /* -------------------- FAQ accordion --------------------------- */
  document.addEventListener("click", (e) => {
    const toggle = e.target.closest("[data-faq-toggle]");
    if (!toggle) return;
    const item = toggle.parentElement;
    const panel = $("[data-faq-panel]", item);
    const icon = $("[data-faq-icon]", toggle);
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    // Close siblings (single-open accordion, matching the original default).
    const root = toggle.closest("[data-faq]");
    if (root) {
      $$("[data-faq-toggle]", root).forEach((t) => {
        if (t === toggle) return;
        t.setAttribute("aria-expanded", "false");
        const p = $("[data-faq-panel]", t.parentElement);
        const ic = $("[data-faq-icon]", t);
        if (p) { p.classList.remove("grid-rows-[1fr]", "pt-4", "opacity-100"); p.classList.add("grid-rows-[0fr]", "opacity-0"); }
        if (ic) ic.classList.remove("rotate-45");
      });
    }
    toggle.setAttribute("aria-expanded", String(!isOpen));
    if (panel) {
      panel.classList.toggle("grid-rows-[1fr]", !isOpen);
      panel.classList.toggle("pt-4", !isOpen);
      panel.classList.toggle("opacity-100", !isOpen);
      panel.classList.toggle("grid-rows-[0fr]", isOpen);
      panel.classList.toggle("opacity-0", isOpen);
    }
    if (icon) icon.classList.toggle("rotate-45", !isOpen);
  });

  /* -------------------- Carousels (auto-slide + prev/next) ------ */
  function initCarousels() {
    const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    $$("[data-carousel]").forEach((car) => {
      const track = $("[data-carousel-track]", car);
      if (!track) return;

      const step = () => {
        const first = track.querySelector(":scope > *");
        const w = first ? first.getBoundingClientRect().width : 320;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "24") || 24;
        return w + gap;
      };
      const prev = $("[data-carousel-prev]", car);
      const next = $("[data-carousel-next]", car);
      if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
      if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));

      // Gentle infinite auto-slide. Recycle the first slide to the end as it
      // scrolls out, so the loop never ends and never jumps.
      const auto = car.getAttribute("data-carousel-auto") !== "false";
      const designMode = window.Shopify && window.Shopify.designMode;
      if (!auto || reduced || designMode) return;
      if (track.children.length < 2) return;

      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "24") || 24;
      const speed = parseFloat(car.getAttribute("data-carousel-speed")) || 0.5; // px per frame ≈ 30px/s
      track.style.overflowAnchor = "none";
      let paused = false;
      // Accumulate the scroll position as a float — scrollLeft rounds to an
      // integer, so sub-pixel increments must be tracked separately.
      let pos = track.scrollLeft;
      const resume = () => { paused = false; pos = track.scrollLeft; };
      car.addEventListener("mouseenter", () => { paused = true; });
      car.addEventListener("mouseleave", resume);
      car.addEventListener("focusin", () => { paused = true; });
      car.addEventListener("focusout", resume);
      track.addEventListener("touchstart", () => { paused = true; }, { passive: true });
      track.addEventListener("touchend", () => { setTimeout(resume, 2500); }, { passive: true });

      function tick() {
        if (!paused && track.scrollWidth > track.clientWidth + 4) {
          pos += speed;
          const first = track.firstElementChild;
          if (first) {
            const firstW = first.getBoundingClientRect().width + gap;
            if (pos >= firstW) {
              track.appendChild(first);
              pos -= firstW;
            }
          }
          track.scrollLeft = pos;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* -------------------- Custom cursor (dot + trailing ring) ----- */
  function initCursor() {
    const dot = $("[data-cursor-dot]");
    const ring = $("[data-cursor-ring]");
    if (!dot || !ring) return;
    // Skip on touch / coarse pointers — nothing to follow.
    if (window.matchMedia && window.matchMedia("(hover: none), (pointer: coarse)").matches) return;

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let dx = mx, dy = my, rx = mx, ry = my;
    let ds = 1, rs = 1;
    let hovering = false, visible = false;

    window.addEventListener("mousemove", (e) => {
      mx = e.clientX; my = e.clientY;
      visible = true;
    }, { passive: true });

    window.addEventListener("mouseover", (e) => {
      const t = e.target;
      hovering = !!(t && t.closest && (t.closest("a") || t.closest("button") || t.closest("[role='button']") || t.closest("label[for]")));
    }, { passive: true });

    document.addEventListener("mouseleave", () => { visible = false; });

    const lerp = (a, b, n) => a + (b - a) * n;
    function frame() {
      // Dot tracks tightly; ring trails more slowly (mirrors the spring feel).
      dx = lerp(dx, mx, 0.35); dy = lerp(dy, my, 0.35);
      rx = lerp(rx, mx, 0.18); ry = lerp(ry, my, 0.18);
      ds = lerp(ds, hovering ? 2.5 : 1, 0.2);
      rs = lerp(rs, hovering ? 1.5 : 1, 0.2);
      dot.style.transform = "translate(" + dx + "px," + dy + "px) translate(-50%,-50%) scale(" + ds + ")";
      ring.style.transform = "translate(" + rx + "px," + ry + "px) translate(-50%,-50%) scale(" + rs + ")";
      dot.style.opacity = visible ? "1" : "0";
      ring.style.opacity = visible ? "0.3" : "0";
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* -------------------- Scroll reveal (IntersectionObserver) ---- */
  function initReveal() {
    const els = $$(".reveal");
    if (!("IntersectionObserver" in window) || els.length === 0) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "-80px", threshold: 0.05 });
    els.forEach((el) => io.observe(el));
  }

  /* -------------------- Hero video alternator ------------------ */
  function initHeroVideo() {
    const v = $("[data-hero-video]");
    if (!v) return;
    const a = v.getAttribute("data-video-1");
    const b = v.getAttribute("data-video-2");
    // With only one video uploaded there is nothing to alternate to, so loop it
    // rather than swapping in an empty src and blanking the hero.
    if (!b) { v.loop = true; return; }
    v.addEventListener("ended", () => {
      const current = v.getAttribute("src");
      v.setAttribute("src", current === a ? b : a);
      v.load();
      v.play().catch(() => {});
    });
  }

  /* -------------------- Announcement marquee ------------------- */
  // The CSS animation translates the track by -50%, which only loops seamlessly
  // when the track is exactly two identical halves AND one half is at least as
  // wide as the viewport. With a short announcement the group is narrower than
  // the screen, so a blank gap scrolls through. Clone the group in pairs until
  // one half covers the viewport, then set the duration from the distance so
  // the speed stays constant no matter how much text the merchant enters.
  const MARQUEE_SPEED = 45; // px per second

  function initMarquee() {
    const track = $("[data-marquee]");
    if (!track) return;

    const groups = $$("[data-marquee-group]", track);
    if (!groups.length) return;

    const original = groups[0];
    const build = () => {
      $$("[data-marquee-clone]", track).forEach((n) => n.remove());

      const groupWidth = original.offsetWidth;
      if (!groupWidth) return;

      // Must stay even so the two halves remain identical.
      const perHalf = Math.max(1, Math.ceil(window.innerWidth / groupWidth));
      const needed = perHalf * 2;

      for (let i = groups.length; i < needed; i++) {
        const clone = original.cloneNode(true);
        clone.setAttribute("data-marquee-clone", "");
        track.appendChild(clone);
      }

      const halfWidth = groupWidth * perHalf;
      track.style.animationDuration = halfWidth / MARQUEE_SPEED + "s";
    };

    build();

    // Fonts load after first paint and change the measured width.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(build).catch(() => {});
    }

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 150);
    });
  }

  /* -------------------- Quantity stepper ----------------------- */
  // Replaces the old inline onclick handlers. Those ran parseInt on the raw
  // field, so clearing it and pressing + wrote NaN into the cart form, and the
  // minus button stayed enabled at the minimum. Typing is validated here too.
  function initQuantity() {
    $$("[data-qty]").forEach((root) => {
      const input = root.querySelector("[data-qty-input]");
      if (!input) return;

      const min = parseInt(input.getAttribute("min"), 10) || 1;
      const rawMax = parseInt(input.getAttribute("max"), 10);
      const max = isNaN(rawMax) ? Infinity : rawMax;

      const current = () => {
        const n = parseInt(input.value, 10);
        return isNaN(n) ? min : n;
      };
      const clamp = (n) => Math.min(max, Math.max(min, n));

      // Reflect limits on the buttons without rewriting what is being typed.
      const paint = () => {
        const n = current();
        root.querySelectorAll("[data-qty-step]").forEach((btn) => {
          const d = parseInt(btn.getAttribute("data-qty-step"), 10);
          btn.disabled = d < 0 ? n <= min : n >= max;
        });
      };

      // Commit: clamp and write back. Used on blur/change and after a step.
      const commit = () => {
        input.value = clamp(current());
        paint();
      };

      root.querySelectorAll("[data-qty-step]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const d = parseInt(btn.getAttribute("data-qty-step"), 10) || 0;
          input.value = clamp(current() + d);
          paint();
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });

      // Only repaint while typing, so a half-typed "1" on the way to "12" is
      // not clamped out from under the user. Clamping happens on commit.
      input.addEventListener("input", paint);
      input.addEventListener("change", commit);
      input.addEventListener("blur", commit);

      commit();
    });
  }

  /* -------------------- Product gallery ------------------------ */
  // Replaces the old inline onclick on each thumbnail, which swapped the main
  // src but left no indication of which image was selected.
  function initGallery() {
    $$("[data-gallery]").forEach((root) => {
      const main = root.querySelector("[data-gallery-main]");
      const strip = root.querySelector("[data-gallery-thumbs]");
      if (!main || !strip) return;

      const thumbs = $$("[data-gallery-thumb]", strip);
      if (!thumbs.length) return;

      const select = (btn, scroll) => {
        const full = btn.getAttribute("data-full");
        if (!full) return;
        main.src = full;
        thumbs.forEach((t) => {
          const on = t === btn;
          t.classList.toggle("is-active", on);
          if (on) t.setAttribute("aria-current", "true");
          else t.removeAttribute("aria-current");
        });
        // Keep the chosen thumbnail visible when it sits outside the viewport,
        // e.g. after the variant picker jumps to a later image.
        if (scroll !== false && btn.scrollIntoView) {
          btn.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
        }
      };

      // Warm the full-size file on intent, so the click itself is instant
      // rather than waiting on a download.
      const warm = (btn) => {
        if (btn.dataset.warmed) return;
        btn.dataset.warmed = "1";
        const full = btn.getAttribute("data-full");
        if (full) { const im = new Image(); im.src = full; }
      };

      thumbs.forEach((btn, i) => {
        btn.addEventListener("click", () => select(btn));
        btn.addEventListener("mouseenter", () => warm(btn));
        btn.addEventListener("focus", () => warm(btn));
        btn.addEventListener("touchstart", () => warm(btn), { passive: true });
        btn.addEventListener("keydown", (e) => {
          if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
          e.preventDefault();
          const dir = e.key === "ArrowRight" ? 1 : -1;
          const nextBtn = thumbs[(i + dir + thumbs.length) % thumbs.length];
          nextBtn.focus();
          select(nextBtn);
        });
      });

      // Arrows only exist while the strip actually overflows.
      const prev = root.querySelector("[data-gallery-prev]");
      const next = root.querySelector("[data-gallery-next]");
      const page = () => Math.max(strip.clientWidth * 0.8, 120);
      if (prev) prev.addEventListener("click", () => strip.scrollBy({ left: -page(), behavior: "smooth" }));
      if (next) next.addEventListener("click", () => strip.scrollBy({ left: page(), behavior: "smooth" }));

      const syncArrows = () => {
        const overflows = strip.scrollWidth > strip.clientWidth + 4;
        if (prev) prev.hidden = !overflows || strip.scrollLeft <= 2;
        if (next) next.hidden = !overflows || strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      };
      strip.addEventListener("scroll", syncArrows, { passive: true });
      window.addEventListener("resize", syncArrows);
      syncArrows();

      // The variant picker drives the gallery through this event.
      root.addEventListener("gallery:select", (e) => {
        const url = e.detail;
        const match = thumbs.filter((t) => t.getAttribute("data-full") === url)[0];
        if (match) select(match);
        else main.src = url;
      });
    });
  }

  /* -------------------- "Viewing now" badge -------------------- */
  // The count is SIMULATED. There is no live visitor data behind it. If real
  // analytics are wired up later, replace the drift below and keep the markup.
  //
  // A naive setInterval with a fresh random number reads as fake immediately:
  // it jumps by large amounts, on a metronome, and resets on every page view.
  // This drifts by small steps at irregular gaps, sometimes holds still, keeps
  // its value across navigation within a session, and stops while the tab is
  // hidden so it does not silently run up while nobody is looking.
  function initViewingNow() {
    $$("[data-viewing]").forEach((el) => {
      const out = el.querySelector("[data-viewing-count]");
      if (!out) return;

      let min = parseInt(el.getAttribute("data-viewing-min"), 10);
      let max = parseInt(el.getAttribute("data-viewing-max"), 10);
      if (isNaN(min)) min = 15;
      if (isNaN(max)) max = 55;
      if (max < min) { const t = min; min = max; max = t; }

      const key = "chillkar-viewing-" + (el.getAttribute("data-viewing-key") || "product");
      const rand = (a, b) => Math.floor(Math.random() * (b - a + 1)) + a;
      const clamp = (n) => Math.min(max, Math.max(min, n));

      const load = () => { try { return parseInt(sessionStorage.getItem(key), 10); } catch (e) { return NaN; } };
      const save = (n) => { try { sessionStorage.setItem(key, String(n)); } catch (e) {} };

      // Resume the session's value; otherwise start inside the middle half of
      // the range, since opening exactly at the floor or ceiling looks staged.
      let n = load();
      if (isNaN(n) || n < min || n > max) {
        const pad = Math.round((max - min) * 0.25);
        n = rand(min + pad, max - pad);
      }

      const render = () => {
        out.textContent = n;
        save(n);
      };

      render();
      el.hidden = false;

      const drift = () => {
        // Weighted so small moves dominate and "no change" happens often.
        const roll = Math.random();
        let delta = 0;
        if (roll > 0.82) delta = rand(2, 3) * (Math.random() < 0.5 ? -1 : 1);
        else if (roll > 0.35) delta = Math.random() < 0.5 ? -1 : 1;

        // Nudge back toward the middle near the edges, so it does not stick.
        if (n <= min + 2) delta = Math.abs(delta);
        if (n >= max - 2) delta = -Math.abs(delta);

        if (delta !== 0) {
          n = clamp(n + delta);
          render();
          el.classList.add("viewing-now--pulse");
          setTimeout(() => el.classList.remove("viewing-now--pulse"), 400);
        }
        schedule();
      };

      let timer = null;
      const schedule = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (document.hidden) { schedule(); return; }
          drift();
        }, rand(5000, 15000));
      };

      schedule();
      document.addEventListener("visibilitychange", () => { if (!document.hidden) schedule(); });
    });
  }

  /* -------------------- Bundle offer --------------------------- */
  // Adds a fixed quantity of the current variant, then goes to checkout where
  // the merchant's Shopify discount does the pricing. Nothing here computes or
  // applies a discount itself.
  function initBundleOffer() {
    $$("[data-bundle-buy]").forEach((el) => {
      el.addEventListener("click", (e) => {
        // Without JS the href is a cart permalink and the browser handles it.
        e.preventDefault();
        if (el.dataset.busy) return;

        const form = $("form[action*='/cart/add']");
        const sel = form ? form.querySelector("[data-variant-select]") : null;
        // Read the variant at click time so a variant switch is respected.
        const id = sel && sel.value ? sel.value : el.getAttribute("data-variant");
        const qty = parseInt(el.getAttribute("data-quantity"), 10) || 2;
        if (!id) return;

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        const base = root.charAt(root.length - 1) === "/" ? root.slice(0, -1) : root;
        const code = el.getAttribute("data-discount");
        const target = base + "/checkout" + (code ? "?discount=" + encodeURIComponent(code) : "");

        el.dataset.busy = "1";
        const original = el.textContent;
        el.textContent = "Redirecting\u2026";

        Promise.resolve(cartAdd(id, qty, form, { redirectTo: target })).finally(() => {
          delete el.dataset.busy;
          el.textContent = original;
        });
      });
    });
  }

  /* -------------------- Bundle tabs ---------------------------- */
  // "Pack of N" tabs above the bundle cards: one card visible at a time.
  // The first card is visible in the markup already, so with JS off the
  // shopper still gets a working (if single) offer.
  function initBundleTabs() {
    $$("[data-bundles]").forEach((root) => {
      const tabs = $$("[data-bundle-tab]", root);
      const cards = $$("[data-bundle]", root);
      if (tabs.length < 2 || tabs.length !== cards.length) return;

      const activate = (index, focus) => {
        tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute("aria-selected", on ? "true" : "false");
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        cards.forEach((card, i) => { card.hidden = i !== index; });
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener("click", () => activate(i, false));
        tab.addEventListener("keydown", (e) => {
          let next = null;
          if (e.key === "ArrowRight" || e.key === "ArrowDown") next = (i + 1) % tabs.length;
          else if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === "Home") next = 0;
          else if (e.key === "End") next = tabs.length - 1;
          if (next === null) return;
          e.preventDefault();
          activate(next, true);
        });
      });

      // In the theme editor, selecting a Bundle block reveals its card.
      document.addEventListener("shopify:block:select", (e) => {
        const i = cards.indexOf(e.target);
        if (i > -1) activate(i, false);
      });
    });
  }

  /* -------------------- Scroll progress bar -------------------- */
  function initScrollProgress() {
    const bar = $(".scroll-progress");
    if (!bar) return;
    const update = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight || 1);
      bar.style.transform = `scaleX(${Math.min(1, Math.max(0, scrolled))})`;
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  const init = () => { initReveal(); initScrollProgress(); initHeroVideo(); initCursor(); initCarousels(); initMarquee(); initQuantity(); initViewingNow(); initGallery(); initBundleOffer(); initBundleTabs(); };

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
